// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-3yb","questions":"styles_questions__5Xzm2","footer":"styles_footer__dcneo"};